"use client";

import { InputHTMLAttributes } from "react";
import clsx from "clsx";
import { Button } from "@/components/ui//forms/button";

interface InputButtonProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  onClick?: () => void;
  buttonText?: string;
}

export const InputButton = ({
  className,
  onClick,
  buttonText = "Go",
  ...props
}: InputButtonProps) => {
  return (
    <div
      className={clsx(
        "flex items-center min-w-0  justify-between rounded-[10px] border pr-[6px] py-[7px] pl-[28px] gap-2 border-[#D9D9D9]",
        className
      )}
    >
      <input
        type="text"
        className="w-full bg-transparent outline-none text-sm text-[#8A8A8A] placeholder-[#8A8A8A] font-[600]"
        {...props}
      />
      <Button
        className="h-[42px] min-w-[160px] rounded-[10px] font-[600] text-[14px] px-0!"
        onClick={onClick}
      >
        {buttonText}
      </Button>
    </div>
  );
};
